<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col cols="8" lg="4">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form name="login">
                  <h1>{{ $t('auth.login_title') }}</h1>
                  <p v-show="!isLoginFailed" class="text-muted">
                    {{ $t('auth.login_description') }}
                  </p>
                  <p v-show="isLoginFailed" class="text-danger">{{ $t('auth.failed') }}</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-user"/></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input ref="email" @keydown.enter.native="attemptLogin" v-model="email"
                                  type="text" class="form-control"
                                  :placeholder=" $t('global.email') "
                                  autocomplete="username-email"/>
                  </b-input-group>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text>
                      <i class="icon-lock"/></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input @keydown.enter.native="attemptLogin" name="password" v-model="password"
                                  type="password" class="form-control"
                                  :placeholder=" $t('global.password') "
                                  autocomplete="current-password" />
                  </b-input-group>
                  <b-input-group class="mb-4" >
                    <b-form-checkbox name="remember" v-model="remember" class="">{{$t('global.remember')}}</b-form-checkbox>
                  </b-input-group>
                  <b-row>
                    <b-col cols="12">
                      <b-button-group class="d-flex">
                        <LanguagesDropdown/>
                        <b-button name="login" block variant="primary" class="px-4 w-100" @click="attemptLogin()"
                                  :disabled="isLoading">{{ $t('auth.login') }}</b-button>
                      </b-button-group>
                    </b-col>
                  </b-row>
                  <!-- <b-row>
                    <b-col cols="6" class="text-left">
                      <b-button variant="link" class="px-0"
                                :to="{ name: 'Register' }">{{ $t('auth.register_link') }}</b-button>
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                                :to="{ name: 'PasswordForgot' }">
                        {{ $t('auth.forgot_password_link')}}
                      </b-button>
                    </b-col>
                  </b-row> -->
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VT from '@/store/types';
import LanguagesDropdown from '@/containers/Dropdowns/LanguagesDropdown';

export default {
  mounted() {
    this.$refs.email.$el.focus();
  },
  data() {
    return {
      email: '',
      password: '',
      remember: false,
      remember_name: navigator.userAgent,
      isLoading: false,
      isLoginFailed: false,
    };
  },
  components: { LanguagesDropdown },
  computed: {
    ...mapGetters('Auth', ['user']),
  },
  methods: {
    ...mapActions('Auth', [VT.LOGIN]),
    attemptLogin() {
      this.isLoginFailed = false;
      this.isLoading = true;
      this[VT.LOGIN](this.$data).then(() => {
        const redirectPath = sessionStorage.getItem('redirectPath');
        if (redirectPath) {
          sessionStorage.removeItem('redirectPath');
          this.$router.replace({ path: redirectPath });
        } else {
          this.$router.replace({ name: 'Dashboard' });
        }
      }).catch(() => {
        this.isLoginFailed = true;
        this.isLoading = false;
      });
    },
  }
};
</script>
